'use strict';

angular.module('far.profile')
    .controller('ProfileNoticeController', function ($rootScope, Notice, softdeleteable, pagination) {
        var vm = {
            progress: true,
            submitted: false,
            user: null,
            notices: [],
            notices_hide: [],
            type: 0,
            pagination: pagination('notice', {next: nextPage, itemsOnPage: 20}),
            constructor: function (user) {
                vm.user = user;
                vm.pagination.clear()
            },
            delete: function (notice) {
                softdeleteable.delete(notice)
            },
            restore: function (notice) {
                softdeleteable.restore(notice)
            },
            check: function (notice) {
                return softdeleteable.check(notice)
            },
            reload: function() {
                vm.notices = [];
                vm.pagination.clear();
            }
        };

        function nextPage(page, count, type) {
            return Notice.getByUser(vm.user, ((page - 1) * count), count, function (response) {
                vm.totalPages = Math.ceil(response.headers('X-Total-Count') / count);

                response.data.forEach(function (item) {
                    vm.notices.push(item)
                });

                softdeleteable.setModel(Notice);

                vm.progress = false;

                return vm.notices;
            }, vm.type);
        }

        return vm;
    });